import { isEqual } from 'lodash'
export default {
  samsaraConfiguration: ({ samsaraConfiguration }) => samsaraConfiguration,
  samsaraConfigurationMutated: ({ samsaraConfiguration, uneditedSamsaraConfiguration }) => !isEqual(samsaraConfiguration, uneditedSamsaraConfiguration)
}
